var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9961 1.56066C15.1914 1.3654 15.1914 1.04882 14.9961 0.853554L14.289 0.146447C14.0938 -0.0488154 13.7772 -0.0488157 13.5819 0.146446L7.57121 6.15715L1.56066 0.146598C1.3654 -0.0486642 1.04882 -0.0486642 0.853554 0.146598L0.146447 0.853705C-0.0488154 1.04897 -0.0488157 1.36555 0.146446 1.56081L6.157 7.57136L0.146888 13.5815C-0.0483737 13.7767 -0.0483737 14.0933 0.146888 14.2886L0.853995 14.9957C1.04926 15.1909 1.36584 15.1909 1.5611 14.9957L7.57121 8.98558L13.5815 14.9958C13.7767 15.1911 14.0933 15.1911 14.2886 14.9958L14.9957 14.2887C15.191 14.0935 15.191 13.7769 14.9957 13.5816L8.98543 7.57136L14.9961 1.56066Z",
    fill: "#607783"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayX);
export default __webpack_public_path__ + "static/media/grayX.a5be9b469e00e9ca243a5eda002ddbda.svg";
export { ForwardRef as ReactComponent };